import React from 'react';

const Body = ({ className, fillBody, fillTop, fillLines, scale }) => {
  return (
<svg className={className} viewBox="146.558 46.485 192.744 333.901" 
    width={scale ? (192.744 * scale) : "192.744"} 
    height={scale ? (333.901 * scale) : "333.901"}
    xmlns="http://www.w3.org/2000/svg">
  <g>
    <path stroke={'rgb(0, 0, 0)'} fill={fillBody} d="M 146.558 101.474 H 339.302 V 378.386 A 2 2 0 0 1 337.302 380.386 H 148.558 A 2 2 0 0 1 146.558 378.386 V 101.474 Z"/>
    <path stroke={'rgb(0, 0, 0)'} fill={fillTop} d="M 148.558 46.485 H 337.302 A 2 2 0 0 1 339.302 48.485 V 102.041 H 146.558 V 48.485 A 2 2 0 0 1 148.558 46.485 Z"/>
    <rect x="151.66" y="192.744" width="4.535" fill={fillLines} height="180.839" stroke={fillLines}/>
    <rect x="159.66" y="192.744" width="4.535" fill={fillLines} height="180.839" stroke={fillLines}/>
    <rect x="167.66" y="192.744" width="4.535" fill={fillLines} height="180.839" stroke={fillLines}/>
  </g>
</svg>
  );
};

export default Body;